module.exports = __webpack_public_path__ + "static/media/Colette Ray Single Headboard - 120 cm_Grey.ca88ed57.png";